import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

// Utility functions for cookies
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${d.toUTCString()};path=/`;
}

function getCookie(name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showPreferences, setShowPreferences] = useState(false);
  const [analytics, setAnalytics] = useState(false);
  const [marketing, setMarketing] = useState(false);

  // On mount, check if consent cookie is set.
  useEffect(() => {
    const consent = getCookie("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAcceptAll = () => {
    const consent = JSON.stringify({ analytics: true, marketing: true });
    setCookie("cookieConsent", consent, 365);
    setShowBanner(false);
    window.dispatchEvent(new Event('cookieConsentChanged')); // <--- Add this line
  };

  const handleRejectAll = () => {
    const consent = JSON.stringify({ analytics: false, marketing: false });
    setCookie("cookieConsent", consent, 365);
    setShowBanner(false);
    window.dispatchEvent(new Event('cookieConsentChanged')); // <--- Add this line
  };

  const handleSavePreferences = () => {
    const consent = JSON.stringify({ analytics, marketing });
    setCookie("cookieConsent", consent, 365);
    setShowBanner(false);
    window.dispatchEvent(new Event('cookieConsentChanged')); // <--- Add this line
  };

  return (
    <AnimatePresence>
      {showBanner && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 right-0  p-4 z-50"
        >
          <Card className="max-w-4xl bg-prime-50 shadow-xl rounded-lg mx-auto">
            <CardHeader>
              <h3 className="text-xl font-serif font-semibold text-prime-950">Cookie-Einstellungen</h3>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-gray-600 pb-5">
                Diese Website verwendet Cookies, um Ihnen ein optimales Nutzererlebnis zu bieten. Essenzielle Cookies sind dabei erforderlich, um den Betrieb der Website zu gewährleisten. Zusätzlich setzen wir optionale Analyse-Cookies (Google Analytics und Clarity) sowie Marketing-Cookies (Meta Pixel) ein. Bitte wählen Sie, ob Sie alle Cookies akzeptieren, alle ablehnen oder Ihre individuellen Präferenzen anpassen möchten.
              </p>
              {!showPreferences && (
                <div className="mt-4 flex  md:flex-row-reverse flex-wrap md:flex-nowrap gap-2 justify-end">
                   <Button className="w-full md:w-fit" variant="outline" onClick={() => setShowPreferences(true)}>
                    Präferenzen
                  </Button>
                  <div className="flex md:flex-row-reverse w-full gap-2">
                  <Button className="w-full md:w-fit" variant="outline" onClick={handleRejectAll}>
                    Alle ablehnen
                  </Button>
                 
                  <Button className="w-full md:w-fit" variant="outline" onClick={handleAcceptAll}>
                    Alle akzeptieren
                  </Button>

                  </div>
                </div>
              )}
              {showPreferences && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  className="mt-4"
                >
                  <div className="flex items-center justify-between py-2">
                    <Label className="text-sm">Analyse-Cookies</Label>
                    <Switch checked={analytics} onCheckedChange={setAnalytics} />
                  </div>
                  <div className="flex items-center justify-between py-2">
                    <Label className="text-sm">Marketing-Cookies</Label>
                    <Switch checked={marketing} onCheckedChange={setMarketing} />
                  </div>
                  <div className="mt-4 flex gap-2 justify-end">
                    <Button variant="outline" onClick={() => setShowPreferences(false)}>
                      Zurück
                    </Button>
                    <Button variant="default" onClick={handleSavePreferences}>
                      Speichern
                    </Button>
                  </div>
                </motion.div>
              )}
            </CardContent>
          </Card>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
